var gtg_modal, setSiteCookies;

setSiteCookies = require('../../../../core/frontend/groupon_modules/setSiteCookies');


/*
 *  LS-2476 / LS-2480 - GTG (GrouponToGo) modal shared code across desktop / touch / m2016
 */

gtg_modal = (function() {
  return {
    init: function() {
      var $html, $modal, $modalAndWrapper, $picture, $wrapper, highres, lowres, ref;
      if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('gtg_modal') : void 0) || Cookie.get('gtg_modal')) {
        return;
      }
      if (!($modal = $('#ls-gtg-modal')).length) {
        return;
      }
      $wrapper = $('#ls-modals-wrapper');
      $html = $('html');
      $modalAndWrapper = $wrapper.add($modal);
      $picture = $modal.find('#ls-gtg-image');
      ref = $picture.data(), lowres = ref.lowres, highres = ref.highres;
      $picture.prepend("<source media='(min-width: 600px)' srcset='" + highres + "'>");
      $picture.find('img').one('load', function() {
        $modalAndWrapper.removeClass('ls-hide');
        return $html.addClass('blockContentScrolling');
      }).attr('src', lowres);
      $modal.on('click', function(e) {
        e.preventDefault();
        return e.stopImmediatePropagation();
      });
      return $wrapper.add('.ls-gtg-content a').one('click', function(e) {
        $modal.off('click');
        e.stopImmediatePropagation();
        if (localStorage) {
          if (typeof localStorage !== "undefined" && localStorage !== null) {
            localStorage.setItem('gtg_modal', true);
          }
        } else {
          setSiteCookies({
            gtg_modal: true
          }, 60 * 60 * 24 * 30);
        }
        $modalAndWrapper.addClass('ls-hide');
        return $html.removeClass('blockContentScrolling');
      });
    }
  };
})();

module.exports = gtg_modal;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvc2hhcmVkL21vZGFscy9mcm9udGVuZC9ndGctbW9kYWwuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvc2hhcmVkL21vZGFscy9mcm9udGVuZC9ndGctbW9kYWwuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxHQUFpQixPQUFBLENBQVEsMERBQVI7OztBQUVqQjs7OztBQUdBLFNBQUEsR0FBZSxDQUFBLFNBQUE7U0FDYjtJQUFBLElBQUEsRUFBTSxTQUFBO0FBQ0osVUFBQTtNQUFBLG9FQUFVLFlBQVksQ0FBRSxPQUFkLENBQXNCLFdBQXRCLFdBQUEsSUFBc0MsTUFBTSxDQUFDLEdBQVAsQ0FBVyxXQUFYLENBQWhEO0FBQUEsZUFBQTs7TUFDQSxJQUFVLENBQUksQ0FBQyxNQUFBLEdBQVMsQ0FBQSxDQUFFLGVBQUYsQ0FBVixDQUE2QixDQUFDLE1BQTVDO0FBQUEsZUFBQTs7TUFFQSxRQUFBLEdBQVcsQ0FBQSxDQUFFLG9CQUFGO01BQ1gsS0FBQSxHQUFRLENBQUEsQ0FBRSxNQUFGO01BQ1IsZ0JBQUEsR0FBbUIsUUFBUSxDQUFDLEdBQVQsQ0FBYSxNQUFiO01BQ25CLFFBQUEsR0FBVyxNQUFNLENBQUMsSUFBUCxDQUFZLGVBQVo7TUFDWCxNQUFvQixRQUFRLENBQUMsSUFBVCxDQUFBLENBQXBCLEVBQUMsbUJBQUQsRUFBUztNQUNULFFBQVEsQ0FBQyxPQUFULENBQWlCLDZDQUFBLEdBQThDLE9BQTlDLEdBQXNELElBQXZFO01BQ0EsUUFBUSxDQUFDLElBQVQsQ0FBYyxLQUFkLENBQW9CLENBQUMsR0FBckIsQ0FBeUIsTUFBekIsRUFBaUMsU0FBQTtRQUMvQixnQkFBZ0IsQ0FBQyxXQUFqQixDQUE2QixTQUE3QjtlQUNBLEtBQUssQ0FBQyxRQUFOLENBQWUsdUJBQWY7TUFGK0IsQ0FBakMsQ0FHQyxDQUFDLElBSEYsQ0FHTyxLQUhQLEVBR2MsTUFIZDtNQU1BLE1BQU0sQ0FBQyxFQUFQLENBQVUsT0FBVixFQUFtQixTQUFDLENBQUQ7UUFDakIsQ0FBQyxDQUFDLGNBQUYsQ0FBQTtlQUNBLENBQUMsQ0FBQyx3QkFBRixDQUFBO01BRmlCLENBQW5CO2FBSUEsUUFBUSxDQUFDLEdBQVQsQ0FBYSxtQkFBYixDQUFpQyxDQUFDLEdBQWxDLENBQXNDLE9BQXRDLEVBQStDLFNBQUMsQ0FBRDtRQUM3QyxNQUFNLENBQUMsR0FBUCxDQUFXLE9BQVg7UUFDQSxDQUFDLENBQUMsd0JBQUYsQ0FBQTtRQUNBLElBQUcsWUFBSDs7WUFDRSxZQUFZLENBQUUsT0FBZCxDQUFzQixXQUF0QixFQUFtQyxJQUFuQztXQURGO1NBQUEsTUFBQTtVQUdFLGNBQUEsQ0FBZTtZQUFDLFNBQUEsRUFBVyxJQUFaO1dBQWYsRUFBa0MsRUFBQSxHQUFLLEVBQUwsR0FBVSxFQUFWLEdBQWUsRUFBakQsRUFIRjs7UUFJQSxnQkFBZ0IsQ0FBQyxRQUFqQixDQUEwQixTQUExQjtlQUNBLEtBQUssQ0FBQyxXQUFOLENBQWtCLHVCQUFsQjtNQVI2QyxDQUEvQztJQXBCSSxDQUFOOztBQURhLENBQUEsQ0FBSCxDQUFBOztBQStCWixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
